/**
 * The people row that ties one person to ONE Member Association, whichever kind of membership it
 * records.
 *
 * A person carries two rows on the wire: their primary membership and their honorary affiliation.
 * The two usually name different associations, so a screen belonging to one association has to
 * ask for the row that names it rather than reaching for the primary one - otherwise an Honorary
 * Fellow of this association reads as "not one of ours" because their primary membership is
 * somewhere else.
 *
 * @param {object} user                 a serialized user from a people list
 * @param {number} memberAssociationId  the association whose screen is asking
 * @returns {object|null} the matching people row, or null when the person has none here
 */
const getMaMembershipRow = (user, memberAssociationId) => {
  if (!user || !memberAssociationId) return null;

  const rows = [user.memberAssociationPeople, user.honoraryMemberAssociationPeople];

  return (
    rows.find(
      (row) => row && row.memberAssociation && row.memberAssociation.id === memberAssociationId,
    ) || null
  );
};

export default getMaMembershipRow;
